export default __webpack_public_path__ + "static/media/bookmark-plus.ab597ef6.svg";